import { defineMessages } from "react-intl";

import {
	igGMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/viral-serology/cmv";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	cmv: {
		id: "ktx.cmv.title",
		defaultMessage: "CMV"
	},
	igg: {
		id: "ktx.cmv.field.igg",
		defaultMessage: "IgG"
	},
	igm: {
		id: "ktx.cmv.field.igm",
		defaultMessage: "IgM"
	}
});

const fields: { [key: string]: FieldData } = {
	igG: {
		type: "field",
		path: ["igG"],
		label: messages.igg,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	},
	igM: {
		type: "field",
		path: ["igM"],
		label: messages.igm,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: igGMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.igG }] },
		{ columns: [{ width: 12, field: fields.igM }] }
	]
};

export const node: LeafNode = {
	id: "ktx_cmv",
	value: {
		schemaId: "cmv",
		title: messages.cmv,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
